import { render, staticRenderFns } from "./MethodInfo.vue?vue&type=template&id=7620883c&"
import script from "./MethodInfo.vue?vue&type=script&lang=js&"
export * from "./MethodInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports